import { RelSchedaProgettoLayerModel } from "./relSchedaProgettoLayer.model";

export class ModifyFeatureSchedaPrjLayINModel {
  relSchedaProgettoLayer: RelSchedaProgettoLayerModel;
}